<template>
  <div class="report-list-wrapper">
    <div class="year-wrapper">
      <ul class="year-list">
        <li
          v-for="year in years"
          :key="year"
          :class="{
            'year-list-item': true,
            'current': selectedYear === year
          }"
          @click="setSelectedYear(year)"
        >{{ year }}</li>
      </ul>
    </div>

    <div class="report-wrapper">
      <div v-for="(reports, year) in yearReports" :key="year" v-show="selectedYear === year">
        <v-checkbox
          name="reports[]"
          v-for="report in reports"
          :key="report.id"
          :label="report.title + ' ' + report.subtitle_formatted + ' (' + report.price_formatted + '円)'"
          :value="report.id"
        >
        </v-checkbox>
      </div>
    </div>

    <div class="report-alert" v-if="errorReports">
      {{ errorReports }}
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'yearReports',
    'errorReports',
  ],

  data () {
    return {
      years: null,
      selectedYear: null
    }
  },

  methods: {
    setSelectedYear (year) {
      this.selectedYear = year
    }
  },

  mounted () {
    const years = Object.keys(this.yearReports).sort((a, b) => {
      return a < b ? 1 : -1
    })

    this.years = years
    this.selectedYear = years[0]
  }
}
</script>

<style lang="scss" scoped>
  @import '../../sass/variables';

  .report-list-wrapper {
    margin-bottom: 50px;
  }

  .report-alert {
    color: #ff5252;
    margin-top: 15px;
    font-size: 1.1rem;
  }

  .year-list {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    &-item {
      list-style: none;
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 1.1rem;
      padding: 5px 15px;
      margin-right: 20px;
      font-weight: bold;
      border-radius: 5px;
      background: #333;
      color: #fff;
      opacity: .5;

      @media (max-width: 1024px) {
        margin-bottom: 10px;
      }

      &.current {
        color: #fff;
        font-weight: bold;
        opacity: 1;
      }
    }
  }
</style>

<style lang="scss">
  .report-wrapper .v-input__slot {
    margin-bottom: 0 !important;
  }

  .report-wrapper .v-messages {
    display: none !important;
  }
</style>
